import { Controller } from "@hotwired/stimulus";

export class RemoveElementController extends Controller {
  removeElement(event) {
    const id = event.currentTarget.dataset.id;
    const element = document.getElementById(id);

    if (element) {
      element.remove();
    }
  }
}
